import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftaccessComponent } from './simple-icons-microsoftaccess.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftaccessComponent ],
    exports:      [ SimpleIconsMicrosoftaccessComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftaccessModule {}
